<div>
    <div class="modal-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg" style="display: flex; align-items: center">
                    <img class="modal-icon" style="width: 35px;" src="assets/ico/jira-brands.svg" alt="icon">
                    <span class="modal-title" id="modal-basic-title">
                        <span> {{ 'order.budget.project.successTitle' | translate }} </span>
                    </span>
                </div>
                <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close"
                    [inlineSVG]="'assets/ico/close-24px.svg'"></div>
            </div>
        </div>
    </div>


    <div class="modal-body mb-5">
        <div id="picker" style="margin-top: -20px;">
            <div class="row">
                <div style="margin-bottom: 20px;">Creation of Project <strong>{{projectName}}</strong>
                    (<em>{{projectKey}}</em>) successfully completed.
                    <br>
                    You can now complete additional configurations:
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="row align-items-center mb-4">
                        <div class="col-sm-2 img-button" (click)="goTo(workspaceResourceUrl, 'workspaceResourceUrl')">
                            <div [ngClass]="{'visited-button' :  isChecked('workspaceResourceUrl')}">
                            </div>
                            <div *ngIf=" isChecked('workspaceResourceUrl')" class="visited-check">
                                <img src="assets/ico/check-mark-green.png" alt="board">
                            </div>
                            <div [ngClass]="{'visited-img-blur' :  isChecked('workspaceResourceUrl')}">
                                <img src="assets/ico/board.svg" alt="board">
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <p class="bold">{{'order.budget.project.workspaceResources' | translate}}</p>
                            <p class="mb-0">{{'order.budget.project.configureWorkspaceResources' | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="row align-items-center mb-4">
                        <div class="col-sm-2 img-button" (click)="goTo(userManagementUrl,'userManagementUrl')">
                            <div [ngClass]="{'visited-button' :  isChecked('userManagementUrl')}">
                            </div>
                            <div *ngIf=" isChecked('userManagementUrl')" class="visited-check">
                                <img src="assets/ico/check-mark-green.png" alt="board">
                            </div>
                            <div [ngClass]="{'visited-img-blur' :  isChecked('userManagementUrl')}">
                                <img src="assets/ico/users.svg" alt="board">
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <p class="bold">{{'order.budget.project.goToUserManagement' | translate}}</p>
                            <p class="mb-0">{{'order.budget.project.addMoreUser' | translate}}</p>
                        </div>

                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="row align-items-center mb-4">
                        <div class="col-sm-2 img-button" (click)="goTo(projectDataUrl,'projectDataUrl')">
                            <div [ngClass]="{'visited-button' :  isChecked('projectDataUrl')}">
                            </div>
                            <div *ngIf=" isChecked('projectDataUrl')" class="visited-check">
                                <img src="assets/ico/check-mark-green.png" alt="board">
                            </div>
                            <div [ngClass]="{'visited-img-blur' :  isChecked('projectDataUrl')}">
                                <img src="assets/ico/data.svg" alt="board">
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <p class="bold">{{'order.budget.project.goToProjectData' | translate}}</p>
                            <p class="mb-0">{{'order.budget.project.configureProjectDataFields' | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="row align-items-center mb-4">
                        <div class="col-sm-2 img-button" [ngClass]="{'visited-block' :  isChecked('sendMail')}"
                            (click)="triggerDetailsModal()">
                            <div [ngClass]="{'visited-button' : isChecked('sendMail')}">
                            </div>
                            <div *ngIf=" isChecked('sendMail')" class="visited-check">
                                <img src="assets/ico/check-mark-green.png" alt="board">
                            </div>
                            <div [ngClass]="{'visited-img-blur' :  isChecked('sendMail')}">
                                <img src="assets/ico/send-mail.svg" alt="board">
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <p class="bold">{{'order.budget.project.goToSendNotification' | translate}}</p>
                            <p class="mb-0">{{'order.budget.project.addEmailNotification' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>